import React from "react";
import { CheckIcon } from "lucide-react";
import { images, offerPerks, offerStack } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
export function Offer() {
  return <section id="offer" className="bg-navy-900 px-5 py-16 md:py-24" data-id="element-184" data-mp="35640xvlpdbjc">
      <div className="mx-auto max-w-xl" data-id="element-185" data-mp="3549e2bqvf9cm">
        <h2 className="text-center font-serif text-3xl font-bold leading-tight text-white md:text-5xl" data-id="element-186" data-mp="3a5yte3l4m96i">
          Here's everything you'll <em className="text-gold-400" data-id="element-187" data-mp="3f38onzv75f29">receive today</em>
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white ring-4 ring-gold-400" data-id="element-188" data-mp="3juqhg0n2g9c5">
          <div className="bg-gold-400 py-2.5 text-center text-sm font-extrabold uppercase tracking-wider text-navy-950" data-id="element-189" data-mp="3nwlo7knrnexb">
            Special launch offer
          </div>
          <div className="p-5 md:p-8" data-id="element-190" data-mp="3su3q4r3d8tvt">
            <img src={images.mainMockup} alt="Everything included in Rhinoplasty MasterMap™" className="mx-auto w-full" data-id="element-191" data-mp="1ou7xllm5jwr" />

            <ul className="mt-4 divide-y divide-cream-200" data-id="element-192" data-mp="1km9j2vbw3rpv">
              {offerStack.map(o => <li key={o.title} className="flex items-start justify-between gap-4 py-4" data-id="element-193" data-mp="1flls29nnvavn">
                  <div data-id="element-194" data-mp="1bll5u2ublve1">
                    <p className="font-bold text-ink" data-id="element-195" data-mp="1bl1yfg2aqpe9">{o.title}</p>
                    <p className="text-sm text-muted" data-id="element-196" data-mp="16mqnt346gauz">{o.detail}</p>
                  </div>
                  <span className="shrink-0 font-semibold text-red-600 line-through" data-id="element-197" data-mp="23c7sberfbqv3">${o.value}</span>
                </li>)}
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-198" data-mp="1zb5zpgs0id23">
                <p className="font-extrabold uppercase tracking-wide text-ink" data-id="element-199" data-mp="1uicvqv4db8r2">Total value</p>
                <span className="text-lg font-extrabold text-red-600 line-through" data-id="element-200" data-mp="1pji1mx0y9xrn">$244</span>
              </li>
            </ul>

            <div className="mt-2 text-center" data-id="element-201" data-mp="2n19wb46s9cjl">
              <p className="text-sm font-bold uppercase tracking-wider text-muted" data-id="element-202" data-mp="2i8p4u9bcnbj8">Today you get everything for only</p>
              <p className="mt-1 font-serif text-7xl font-extrabold leading-none text-navy-950 md:text-8xl" data-id="element-203" data-mp="316il0pp82wj5">$27</p>
              <p className="mt-2 font-semibold text-emerald-700" data-id="element-204" data-mp="364288f3wejn8">You save $217 (89% off)</p>
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-205" data-mp="2scx5331bn985">
              {offerPerks.map(p => <li key={p} className="flex items-center gap-2 rounded-xl bg-cream-100 px-3 py-2.5 text-sm font-semibold text-ink" data-id="element-206" data-mp="2wcxutjtvf6ui">
                  <CheckIcon className="h-4 w-4 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-207" data-mp="2ndsuq92nv5g8" />
                  {p}
                </li>)}
            </ul>

            <CtaButton className="mt-7" label="Yes — I want the MasterMap" note="One-time payment of $27 · Instant download · Lifetime access · 7-day guarantee" data-id="element-208" data-mp="29gnpgbaruam1" />

            <div className="mt-8 space-y-6" data-id="element-209" data-mp="bo9q992d03ih">
              <Countdown data-id="element-210" data-mp="bo00nml87ydb" />
              <ScarcityBar data-id="element-211" data-mp="bm73qz0f0sii" />
            </div>
          </div>
        </div>

        <p className="mt-8 text-center text-[15px] leading-relaxed text-navy-100" data-id="element-212" data-mp="1w73v8tgml23h">
          For less than the cost of a typical professional reference, you'll have a complete visual system to return to whenever you study a rhinoplasty case.
        </p>
      </div>
    </section>;
}